<div class='weekdays-list' *ngIf="device === 'mobile'">
  <div class="weekdays-day" *ngFor="let day of weekDays; let i = index" (click)="goToDate(i)"><b>{{day}}</b></div>
</div>

<div class="error" *ngIf="errors && errors.errorOverlap" translate>
  <i class="material-icons">warning</i>
  teacher.schedule.error.error-overlap
</div>
<div class="error" *ngIf="errors && errors.errorPast" translate>
  <i class="material-icons">warning</i>
  teacher.schedule.error.error-past-event
</div>
<div class="error" *ngIf="errors && errors.errorTwoDays" translate>
  <i class="material-icons">warning</i>
  teacher.schedule.error.error-two-days
</div>

<full-calendar 
    #generalCalendar
    [options]="calendarOptions"
  >
  </full-calendar>
  <mat-spinner *ngIf="loading" class="loader"></mat-spinner>
